
export const LICENSE_REQUEST = "LICENSE_REQUEST"
export const LICENSE_REQUEST_SUCCESS = "LICENSE_REQUEST_SUCCESS"
export const LICENSE_REQUEST_FAILED = "LICENSE_REQUEST_FAILED"
export const LICENSE_PROCESS_RESET = "LICENSE_PROCESS_RESET"


export interface LicenseRequest {
  type: typeof LICENSE_REQUEST
}
export interface LicenseRequestSuccess {
  type: typeof LICENSE_REQUEST_SUCCESS,
  payload?:any
}
export interface LicenseRequestFailed {
  type: typeof LICENSE_REQUEST_FAILED,
  payload:{}
}
export interface LicenseProcessReset {
  type: typeof LICENSE_PROCESS_RESET
}


export type LicenseAction = 
| LicenseRequest
| LicenseRequestSuccess
| LicenseRequestFailed
| LicenseProcessReset

